import { render, staticRenderFns } from "./SubjectPoolView.vue?vue&type=template&id=391a13a4"
import script from "./SubjectPoolView.vue?vue&type=script&lang=js"
export * from "./SubjectPoolView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports